/** What more than one screen says. A string earns a place here by appearing twice. */
export const common = {
  shell: {
    title: "JBNL Wedstrijdplanner - Backoffice",
    product: "Wedstrijdplanner",
    portal: "Backoffice",
    rol: "Wedstrijdleider",
    signOut: "Uitloggen",
  },

  /** The Brandweer Rood band at the foot of every page: who this is, and where JBNL lives. */
  footer: {
    stichting: "Stichting Jeugdbrandweer Nederland",
    website: "JBNL Wedstrijdplanner",
  },

  /** Under the shell of a beheerder who may read but not change (ADR-0078). */
  readOnlyBanner:
    "Je hebt alleen leesrechten. Je kunt alles in de backoffice bekijken, maar niets wijzigen.",

  countdown: {
    opent: "De inschrijving opent over",
    sluit: "De inschrijving sluit over",
    gesloten: "De inschrijving is gesloten.",
    dagEnTijd_one: "{{count}} dag {{tijd}}",
    dagEnTijd_other: "{{count}} dagen {{tijd}}",
    // What a screen reader hears: days, then hours, so it is not read out every second.
    opentOver: "De inschrijving opent over {{resterend}}.",
    sluitOver: "De inschrijving sluit over {{resterend}}.",
    dag_one: "{{count}} dag",
    dag_other: "{{count}} dagen",
    uren: "{{aantal}} uur",
    minderDanEenUur: "minder dan een uur",
  },
  /** "Versie" and not "Version": it is on screen, so it is Dutch. */
  version: {
    label: "Versie {{version}}",
    commit: "Commit {{commit}}",
  },
  theme: {
    label: "Weergave: {{theme}}",
    system: "automatisch",
    light: "licht",
    dark: "donker",
  },

  logoAlt: "Jeugdbrandweer Nederland",
  mailbox: "ict@jeugdbrandweer.nl",
  aanmeldsite: "aanmelden.wedstrijden.jeugdbrandweer.nl",

  /** The refusals. Kept here because eleven pages draw the same two. */
  doors: {
    noAccess: "Geen toegang",
    noAccessDescription: "Deze pagina is voor de wedstrijdleiders.",
    noAccessBackoffice: "Geen toegang tot de backoffice",
    noAccessBackofficeBefore:
      "Deze omgeving is voor de wedstrijdleiders. Ga naar ",
    noAccessBackofficeAfter:
      " om ploegen in te schrijven of je beschikbaarheid door te geven.",
  },

  /** The seizoen line under a page title, and the way to another one. */
  seizoen: {
    /** On its own, where nothing follows it. */
    naam: "Seizoen {{naam}}",
    /** In front of another sentence - "Seizoen 2027. Een andere kies je bij Seizoenen." */
    lopend: "Seizoen {{naam}}.",
    geen: "Nog geen seizoen ingericht.",
    andereBefore: " Een andere kies je bij ",
    geenBefore: "Er is nog geen seizoen. Maak er eerst een aan bij ",
    link: "Seizoenen",
    na: ".",
  },

  actions: {
    busy: "Bezig…",
    cancel: "Annuleren",
    save: "Opslaan",
    create: "Aanmaken",
    delete: "Verwijderen",
    next: "Volgende",
    previous: "Vorige",
    backToStart: "Terug naar het begin",
    close: "Sluiten",
    more: "Meer",
  },
  selectAll: {
    label: "Alles selecteren",
    count: "({{selected}} van {{total}})",
  },
  table: {
    busy: "Bezig met laden…",
    geenResultaten: "Geen resultaten",
    nietsGevonden: "Niets gevonden voor “{{zoekterm}}”.",
    export: "Exporteren",
    filters: {
      wissen: "Wissen",
      toepassen: "Toepassen",
      /** A default nobody set has to say so, or a narrowed list reads as the whole list. */
      standaard: "(standaard aan)",
      ja: "Ja",
      zoek: "Zoek een {{label}}",
      van: "{{label}} van",
      tot: "{{label}} tot en met",
      meer: "Nog {{count}} tonen",
      minder: "Minder tonen",
      /** A closed meerkeuze button falls back to this once more than one option is on. */
      aantalGekozen: "{{count}} gekozen",
      /** Never a bare count while a filter is on - see the DataTable comment. */
      telling_one: "1 rij",
      telling_other: "{{count}} rijen",
      tellingGefilterd_one: "1 van {{totaal}} rijen",
      tellingGefilterd_other: "{{count}} van {{totaal}} rijen",
    },
    pager: {
      label: "Paginering",
      pageOfTotal: "Pagina {{page}} van {{total}}",
      gotoPage: "Ga naar pagina {{page}}",
      morePages: "Meer pagina's",
    },
  },
  /** The pair of reorder buttons on a hand-ordered list. */
  volgorde: {
    omhoog: "{{label}} omhoog",
    omlaag: "{{label}} omlaag",
  },
  /** The shadcn primitives' screen-reader text, which arrives in English and is heard, not seen. */
  sidebar: {
    label: "Zijbalk",
    description: "Toont de zijbalk op een smal scherm.",
    toggle: "Zijbalk in- of uitklappen",
    breadcrumb: "kruimelpad",
  },
  /** One shape for every tab strip, so two panes cannot spell the same thing differently. */
  tabs: {
    metAantal: "{{label}} ({{aantal}})",
  },
  errors: {
    unexpected: "Er is iets misgegaan ({{status}}). Probeer het opnieuw.",
    seizoenen: "Kon de seizoenen niet ophalen.",
  },
} as const;
